<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  background: #f5f6fa;
}
</style>



// WEBPACK FOOTER //
// src/App.vue